function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionStats = function SvgConnectionStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 2 24 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3v12h3.826L8.54 20H5v8h3v1h4v-1h3v-8h-3.826l4.287-5h1.078l4.287 5H17v8h3v1h4v-1h3v-8h-3.54l-4.286-5H23V3zm2 2h10v2H11zm0 4h10v4H11zM7 22h6v4H7zm12 0h6v4h-6z",
    fill: "#fff",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }));
};
export default SvgConnectionStats;